<template>
  <div>
    <div class="lg:col-12 flex flex-wrap w-full align-center mb-1 mt-2" style="margin-left: 1px">
      <SmartInput
        type="date-picker"
        v-model="startDate"
        :not-after="lastDate"
        label="Data Inicial"
        class="sm:col-12 lg:col-3 mb-2"
        name="startDate"
      />
      <SmartInput
        type="date-picker"
        v-model="lastDate"
        :not-before="startDate"
        :not-after="today"
        label="Data Final"
        class="sm:col-12 lg:col-3 mb-2"
        name="lastDate"
      />
      <VSelect
        :items="salesRegionals"
        label="Regional"
        placeholder="Todas Regionais"
        item-text="name"
        item-value="name"
        name="regionals"
        class="sm:col-12 lg:col-4 mb-2 adapt-select"
        v-model="selectedRegional"
      >
        <template v-slot:item="{ item, index }">
          <div class="v-list__tile__content">
            <div :id="`view-${index}`" class="v-list__tile__title">{{ item.name }}</div>
          </div>
        </template>
      </VSelect>
      <SmartButton
        tertiary
        icon
        @click="btnSearch"
        :disabled="enable"
        title="Selecione também o nome ou matrícula do usuário"
        class="inline-flex mr-1 ml-3"
        style="margin-top: 0.75rem"
      >
        <SmartIcon name="search" class="right" :size="2" />
      </SmartButton>
      <SmartButton
        tertiary
        icon
        @click="clearFilter"
        class="inline-flex adapt-btnClear"
        style="margin-top: 0.75rem"
      >
        <SmartIcon name="trash" class="right" :size="2" />
      </SmartButton>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { serialize } from 'utils';

export default {
  name: 'FilterSaleLogs',
  props: {
    enable: Boolean
  },
  data() {
    return {
      startDate: null,
      lastDate: null,
      selectedRegional: ''
    };
  },
  methods: {
    ...mapActions({
      fetchRegionals: 'saleManagement/fetchRegionals'
    }),
    btnSearch() {
      this.$emit('searchWithFilter');
    },
    clearFilter() {
      this.startDate = null;
      this.lastDate = null;
      this.selectedRegional = '';
      this.selectedUserType = '';

      this.$emit('clearFilter');
      this.$emit('searchWithFilter');
    }
  },
  computed: {
    ...mapGetters({
      salesRegionals: 'saleManagement/regionals'
    }),
    today() {
      return moment()
        .add(1, 'days')
        .format('YYYY-MM-DD');
    },
    filters() {
      let filter = {};
      if (this.startDate) {
        const startDate = moment(this.startDate).format('YYYY-MM-DD');
        filter = { ...filter, from: startDate };
      }

      if (this.lastDate) {
        const lastDate = moment(this.lastDate).format('YYYY-MM-DD');
        filter = { ...filter, to: lastDate };
      }

      if (this.selectedRegional) {
        filter = { ...filter, regional: this.selectedRegional };
      }

      return serialize(filter);
    }
  },
  created() {
    this.fetchRegionals();
  }
};
</script>
